module.exports = __webpack_public_path__ + "img/64.4127b9f5.jpg";